export const TITULO_PAGINA_REATIVACAO = 'Reativação da assinatura'

export const DESCRICAO_PAGINA_REATIVACAO = 'Reative sua assinatura para voltar a receber uma surpresa todo mês na porta da sua casa.'

export const LABEL_BOTAO_REATIVACAO = 'Confirmar reativação'

export const BASE_PROPRIEDADE_ASSINATURA_REATIVACAO = 'assinatura_id'

export const BASE_PROPRIEDADE_BRINDE_REATIVACAO = 'brinde'

export const BASE_PROPRIEDADE_ENTREGA_REATIVACAO = 'entrega'

export const BASE_PROPRIEDADE_PAGAMENTO_REATIVACAO = 'pagamento'

export const BASE_PROPRIEDADE_PLANO_REATIVACAO = 'plano'

export const BASE_PROPRIEDADE_CUPONS_REATIVACAO = 'cupons'

export const BASE_PROPRIEDADE_PAGAMENTO_CARTAO_REATIVACAO = 'cartao_credito'

export const SUCESSO_FAZER_REATIVACAO_CARTAO = 'Reativação de assinatura realizada com sucesso!'

export const SUCESSO_FAZER_REATIVACAO_PIX = 'A reativação de assinatura será realizada assim que você fizer o pagamento do seu pix.'

export const BASES_OBRIGATORIAS_REATIVACAO = [
  BASE_PROPRIEDADE_ASSINATURA_REATIVACAO,
  BASE_PROPRIEDADE_BRINDE_REATIVACAO,
  BASE_PROPRIEDADE_ENTREGA_REATIVACAO,
  BASE_PROPRIEDADE_PAGAMENTO_REATIVACAO,
  BASE_PROPRIEDADE_PLANO_REATIVACAO
]

export const BASES_OPCIONAIS_REATIVACAO = [ BASE_PROPRIEDADE_CUPONS_REATIVACAO ]
